import { TGroupListItem } from 'user/types';

export function isGroupSelected(
    selectedGroups: TGroupListItem[],
    group: TGroupListItem
) {
    return selectedGroups.some(
        (selectedGroup) => selectedGroup.id === group.id
    );
}

export function isGroupAdded(
    addedGroups: TGroupListItem[],
    group: TGroupListItem
) {
    return addedGroups.some((addedGroup) => addedGroup.id === group.id);
}

export function getGroupSelectStatus(
    selectedGroups: TGroupListItem[],
    addedGroups: TGroupListItem[],
    group: TGroupListItem
) {
    const isSelected = isGroupSelected(selectedGroups, group);
    const isAdded = isGroupAdded(addedGroups, group);

    return { isSelected, isAdded };
}
